// extracted by mini-css-extract-plugin
export default {"popoverContent":"EntryPopover_popoverContent__ZepHi","popoverItem":"EntryPopover_popoverItem__PxJR5"};